import { render } from "./질병건강정보_상세.vue?vue&type=template&id=66098439"
import script from "./질병건강정보_상세.vue?vue&type=script&lang=js"
export * from "./질병건강정보_상세.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__